import { useState, useEffect } from 'react';

export function useLoadIntermediateScript() {
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = useState(false);

    useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/intermediate';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.onload = () => setScriptLoadedSuccessfully(true);
        scriptTag.onerror = () => setScriptLoadedSuccessfully(false);

        document.head.appendChild(scriptTag);

        return () => {
            document.head.removeChild(scriptTag);
        };
    });

    return scriptLoadedSuccessfully;
}
